import client from "./client";

const getCurrencies = () => client.get("currencies/allowed");
const getCountries = () => client.get('countries/allowed');


export default { getCurrencies, getCountries };
